// string byte length

String.prototype.blength = function() {
  let len = 0;
  for (let i = 0; i < this.length; i++) {
    if (this.charCodeAt(i) > 127 || this.charCodeAt(i) === 94) {
      len += 2;
    } else {
      len ++;
    }
  }
  return len;
};

String.prototype.getByteSize = function() {
  let byteSize = 0;
  for (let i = 0; i < this.length; i++) {
    let charCode = this.charCodeAt(i);
    if (0 <= charCode && charCode <= 0x7f) {
      byteSize += 1;
    } else if (128 <= charCode && charCode <= 0x7ff) {
      byteSize += 2;
    } else if (2048 <= charCode && charCode <= 0xffff) {
      byteSize += 3;
    } else if (65536 < charCode && code <= 0x1FFFFF) {
      byteSize += 4;
    } else if (0x200000 < charCode && charCode <= 0x3FFFFFF) {
      byteSize += 5;
    } else if (0x4000000 < charCode && charCode <= 0x7FFFFFFF) {
      byteSize += 6;
    }
  }
  return byteSize;
}

Array.prototype.updateOrPush = function(item, key = 'id') {
  const idx = this.findIndex(cur => cur[key] === item[key]);
  idx === -1 ? this.push(item) : Object.assign(this[idx], item);
}
Array.prototype.updateOrUnshift = function(item, key = 'id') {
  const idx = this.findIndex(cur => cur[key] === item[key]);
  idx === -1 ? this.unshift(item) : Object.assign(this[idx], item);
}
Array.prototype.remove = function(item, key = 'id') {
  const idx = this.findIndex(cur => cur[key] === item[key]);
  idx === -1 ? console.error('删除失败') : this.splice(idx, 1);
}

Array.prototype.toHash = function(key_key = 'id', val_key = undefined) {
  return Object.assign({}, ...this.map(obj => {
    const key = obj[key_key];
    const val = val_key ? obj[val_key] : obj;
    return {[key]: val};
  }));
}
